import React, { useState, useEffect, useRef } from 'react';
import { Calendar, Phone, Mail, MapPin, Home, Briefcase, MessageSquare, Clock, CheckCircle, Hammer, Building, Wrench, Lock, LogOut, Plus, Trash2, Settings, Menu, X, Image } from 'lucide-react';
import emailjs from '@emailjs/browser';
import { createClient } from '@supabase/supabase-js';

// ========== CONFIGURATION SUPABASE (en dehors du composant) ==========
const SUPABASE_URL = 'https://kxyffdarlvxqvbgfhfqz.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt4eWZmZGFybHZ4cXZiZ2ZoZnF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgwNjQ5ODUsImV4cCI6MjA4MzY0MDk4NX0.3o7HRC8k4_57nfICDTubXvvE8TMwFA_GuIg6H_8aIss';
const supabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
// ========================================

export default function BTBWebsite() {
  // ========== CONFIGURATION ADMIN - MODIFIEZ ICI ==========
  const ADMIN_USERNAME = 'admin';     // Changez le nom d'utilisateur
  const ADMIN_PASSWORD = 'admin1234';  // Changez le mot de passe
  
  // ========== CONFIGURATION EMAIL ==========
  // Votre adresse email pour recevoir les notifications
  const ADMIN_EMAIL = 'bricodecoservicepro@gmail.com';
  
  // Configuration EmailJS - À CONFIGURER (voir instructions ci-dessous)
  const EMAILJS_SERVICE_ID = 'service_8mhzdnk';  // Service ID de EmailJS
  const EMAILJS_TEMPLATE_ID = 'template_t1j929o';  // Template ID de EmailJS
  const EMAILJS_PUBLIC_KEY = '5fAZLCHi_5SFrif9v';  // Public Key de EmailJS
  // ========================================

  const [currentPage, setCurrentPage] = useState('home');
  const [isAdmin, setIsAdmin] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const [disponibilites, setDisponibilites] = useState([]);
  const [loadingDispo, setLoadingDispo] = useState(true);
  const [adminCredentials, setAdminCredentials] = useState({ username: '', password: '' });
  
  const [newDispo, setNewDispo] = useState({ date: '', heures: [] });
  const heuresDisponibles = ['8h', '9h', '10h', '11h', '12h', '14h', '15h', '16h', '17h', '18h'];
  
  const [formData, setFormData] = useState({ nom: '', email: '', telephone: '', message: '', date: '', heure: '', service: '' });
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // Charge les disponibilités depuis Supabase
  useEffect(() => {
    const fetchDisponibilites = async () => {
      try {
        const { data, error } = await supabaseClient
          .from('availabilities')
          .select('*')
          .order('date');
        if (error) throw error;
        setDisponibilites(data || []);
      } catch (error) {
        console.error('Erreur chargement disponibilités:', error);
        // Fallback to localStorage if Supabase fails
        const saved = localStorage.getItem('disponibilites');
        setDisponibilites(saved ? JSON.parse(saved) : []);
      } finally {
        setLoadingDispo(false);
      }
    };
    fetchDisponibilites();
  }, []);

  // Charge les identifiants admin depuis Supabase
  useEffect(() => {
    const fetchAdminCredentials = async () => {
      try {
        const { data, error } = await supabaseClient
          .from('admins')
          .select('username, password')
          .single();
        if (error) throw error;
        setAdminCredentials(data || { username: '', password: '' });
      } catch (error) {
        console.error('Erreur chargement admin:', error);
        // Fallback to hardcoded
        setAdminCredentials({ username: ADMIN_USERNAME, password: ADMIN_PASSWORD });
      }
    };
    fetchAdminCredentials();
  }, []);

  // Sauvegarde les disponibilités dans localStorage à chaque modification (fallback)
  useEffect(() => {
    localStorage.setItem('disponibilites', JSON.stringify(disponibilites));
  }, [disponibilites]);

  // Initialise EmailJS au chargement du composant
  useEffect(() => {
    emailjs.init(EMAILJS_PUBLIC_KEY);
  }, []);

  const services = [
    { icon: <Hammer className="w-12 h-12" />, titre: "Rénovation", description: "Rénovation complète ou partielle de vos espaces intérieurs et extérieurs." },
    { icon: <Home className="w-12 h-12" />, titre: "Aménagement", description: "Aménagement intérieur personnalisé selon vos besoins et envies." },
    { icon: <Building className="w-12 h-12" />, titre: "Carrelages", description: "Pose et rénovation de carrelage pour sols et murs." },
    { icon: <Wrench className="w-12 h-12" />, titre: "Peinture", description: "Travaux de peinture intérieure et extérieure." },
    { icon: <Home className="w-12 h-12" />, titre: "Enduit", description: "Application d'enduit pour finitions murales." },
    { icon: <Building className="w-12 h-12" />, titre: "Parquet", description: "Pose et rénovation de parquet." },
    { icon: <Hammer className="w-12 h-12" />, titre: "Montage de Meuble", description: "Montage professionnel de tous types de meubles." },
    { icon: <Home className="w-12 h-12" />, titre: "Installation de Cuisine", description: "Installation complète de cuisine équipée." },
    { icon: <Wrench className="w-12 h-12" />, titre: "Installation de Salle de Bains", description: "Installation et aménagement de salle de bains." },
    { icon: <Building className="w-12 h-12" />, titre: "Plomberie", description: "Travaux de plomberie et dépannage." },
    { icon: <Hammer className="w-12 h-12" />, titre: "Électricité Petite", description: "Petits travaux d'électricité et dépannage." }
  ];

  // Vérifie identifiants et connecte l'admin
  const handleLogin = () => {
    if (usernameRef.current?.value === adminCredentials.username && passwordRef.current?.value === adminCredentials.password) {
      setIsAdmin(true);
      setCurrentPage('admin');
      setLoginError('');
      // clear refs
      if (usernameRef.current) usernameRef.current.value = '';
      if (passwordRef.current) passwordRef.current.value = '';
    } else {
      setLoginError('Identifiants incorrects');
    }
  };

  const handleLogout = () => { setIsAdmin(false); setCurrentPage('home'); };

  // refs for uncontrolled RDV inputs to avoid re-renders while typing
  const nomRef = useRef(null);
  const emailRef = useRef(null);
  const telRef = useRef(null);
  const serviceRef = useRef(null);
  const dateRef = useRef(null);
  const heureRef = useRef(null);
  const messageRef = useRef(null);
  // refs for Contact page (uncontrolled) to avoid re-renders there too
  const contactNomRef = useRef(null);
  const contactEmailRef = useRef(null);
  const contactTelRef = useRef(null);
  const contactMessageRef = useRef(null);
  
  // refs for Login page (uncontrolled)
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);
  
  
  const handleSubmit = () => {
    const nom = nomRef.current?.value ?? contactNomRef.current?.value ?? formData.nom;
    const email = emailRef.current?.value ?? contactEmailRef.current?.value ?? formData.email;
    const telephone = telRef.current?.value ?? contactTelRef.current?.value ?? formData.telephone;
    const message = messageRef.current?.value ?? contactMessageRef.current?.value ?? formData.message;
    const service = serviceRef.current?.value ?? formData.service;
    const date = dateRef.current?.value ?? formData.date;
    const heure = heureRef.current?.value ?? formData.heure;
    
    if (nom && email && telephone) {
      const templateParams = {
        to_email: ADMIN_EMAIL,
        from_name: nom,
        from_email: email,
        phone: telephone,
        message: message,
        service: service || 'Non spécifié',
        date: date ? new Date(date + 'T00:00:00').toLocaleDateString('fr-FR', {weekday: 'long', day: 'numeric', month: 'long'}) : 'Non spécifié',
        heure: heure || 'Non spécifié'
      };

      emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams)
        .then((response) => {
          console.log('Email envoyé avec succès:', response);
          setSubmitSuccess(true);
          setSubmitError('');
          // clear refs (uncontrolled inputs)
          if (nomRef.current) nomRef.current.value = '';
          if (emailRef.current) emailRef.current.value = '';
          if (telRef.current) telRef.current.value = '';
          if (serviceRef.current) serviceRef.current.value = '';
          if (dateRef.current) dateRef.current.value = '';
          if (heureRef.current) heureRef.current.value = '';
          if (messageRef.current) messageRef.current.value = '';
          if (contactNomRef.current) contactNomRef.current.value = '';
          if (contactEmailRef.current) contactEmailRef.current.value = '';
          if (contactTelRef.current) contactTelRef.current.value = '';
          if (contactMessageRef.current) contactMessageRef.current.value = '';
          setTimeout(() => {
            setSubmitSuccess(false);
            setFormData({ nom: '', email: '', telephone: '', message: '', date: '', heure: '', service: '' });
          }, 3000);
        })
        .catch((error) => {
          console.error('Erreur détaillée:', error);
          setSubmitError(`Erreur: ${error.text || error.message || 'Impossible d\'envoyer le message'}`);
          setTimeout(() => {
            setSubmitError('');
          }, 3000);
        });
    }
  };

  // Ajoute nouvelle disponibilité avec date et heures
  const ajouterDisponibilite = async () => {
    if (newDispo.date && newDispo.heures.length > 0) {
      try {
        const { data, error } = await supabaseClient
          .from('availabilities')
          .insert([{ date: newDispo.date, heures: newDispo.heures }])
          .select();
        if (error) throw error;
        setDisponibilites([...disponibilites, ...data]);
        setNewDispo({ date: '', heures: [] });
      } catch (error) {
        console.error('Erreur ajout disponibilité:', error);
        // Fallback: add locally
        const newId = Math.max(...disponibilites.map(d => d.id || 0), 0) + 1;
        setDisponibilites([...disponibilites, { id: newId, date: newDispo.date, heures: newDispo.heures }]);
        setNewDispo({ date: '', heures: [] });
      }
    }
  };

  // Supprime une disponibilité par son ID
  const supprimerDisponibilite = async (id) => {
    try {
      const { error } = await supabaseClient
        .from('availabilities')
        .delete()
        .eq('id', id);
      if (error) throw error;
      setDisponibilites(disponibilites.filter(d => d.id !== id));
    } catch (error) {
      console.error('Erreur suppression disponibilité:', error);
      // Fallback: remove locally
      setDisponibilites(disponibilites.filter(d => d.id !== id));
    }
  };

  // Ajoute/retire une heure de la sélection
  const toggleHeure = (heure) => {
    if (newDispo.heures.includes(heure)) {
      setNewDispo({ ...newDispo, heures: newDispo.heures.filter(h => h !== heure) });
    } else {
      setNewDispo({ ...newDispo, heures: [...newDispo.heures, heure] });
    }
  };

  // Récupère les heures disponibles pour une date
  const getHeuresDisponiblesPourDate = (date) => {
    const dispo = disponibilites.find(d => d.date === date);
    return dispo ? dispo.heures : [];
  };

  const Navigation = () => (
    <nav className="bg-slate-800 text-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-2">
            <img src="/images/logo/logo.png" alt="BTP Solutions Logo" className="w-12 h-12 object-contain" />
          </div>
          <div className="hidden md:flex items-center space-x-6">
            <button onClick={() => setCurrentPage('home')} className={`flex items-center space-x-1 px-3 py-2 rounded transition ${currentPage === 'home' ? 'bg-orange-500' : 'hover:bg-slate-700'}`}>
              <Home className="w-4 h-4" /><span>Accueil</span>
            </button>
            <button onClick={() => setCurrentPage('services')} className={`flex items-center space-x-1 px-3 py-2 rounded transition ${currentPage === 'services' ? 'bg-orange-500' : 'hover:bg-slate-700'}`}>
              <Briefcase className="w-4 h-4" /><span>Services</span>
            </button>
            <button onClick={() => setCurrentPage('realisations')} className={`flex items-center space-x-1 px-3 py-2 rounded transition ${currentPage === 'realisations' ? 'bg-orange-500' : 'hover:bg-slate-700'}`}>
              <Image className="w-4 h-4" /><span>Réalisations</span>
            </button>
            <button onClick={() => setCurrentPage('contact')} className={`flex items-center space-x-1 px-3 py-2 rounded transition ${currentPage === 'contact' ? 'bg-orange-500' : 'hover:bg-slate-700'}`}>
              <MessageSquare className="w-4 h-4" /><span>Contact</span>
            </button>
            <button onClick={() => setCurrentPage('rdv')} className={`flex items-center space-x-1 px-3 py-2 rounded transition ${currentPage === 'rdv' ? 'bg-orange-500' : 'hover:bg-slate-700'}`}>
              <Calendar className="w-4 h-4" /><span>RDV</span>
            </button>
            {isAdmin ? (
              <>
                <button onClick={() => setCurrentPage('admin')} className={`flex items-center space-x-1 px-3 py-2 rounded transition ${currentPage === 'admin' ? 'bg-orange-500' : 'hover:bg-slate-700'}`}>
                  <Settings className="w-4 h-4" /><span>Admin</span>
                </button>
                <button onClick={handleLogout} className="flex items-center space-x-1 px-3 py-2 rounded hover:bg-red-600 transition">
                  <LogOut className="w-4 h-4" /><span>Déconnexion</span>
                </button>
              </>
            ) : (
              <button onClick={() => setCurrentPage('login')} className={`flex items-center space-x-1 px-3 py-2 rounded transition ${currentPage === 'login' ? 'bg-orange-500' : 'hover:bg-slate-700'}`}>
                <Lock className="w-4 h-4" /><span>Admin</span>
              </button>
            )}
          </div>
          <div className="md:hidden">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-orange-500">
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
        {isMobileMenuOpen && (
          <div className="md:hidden bg-slate-700 py-4">
            <div className="flex flex-col space-y-2 px-4">
              <button onClick={() => { setCurrentPage('home'); setIsMobileMenuOpen(false); }} className={`flex items-center space-x-2 px-3 py-2 rounded transition ${currentPage === 'home' ? 'bg-orange-500' : 'hover:bg-slate-600'}`}>
                <Home className="w-4 h-4" /><span>Accueil</span>
              </button>
              <button onClick={() => { setCurrentPage('services'); setIsMobileMenuOpen(false); }} className={`flex items-center space-x-2 px-3 py-2 rounded transition ${currentPage === 'services' ? 'bg-orange-500' : 'hover:bg-slate-600'}`}>
                <Briefcase className="w-4 h-4" /><span>Services</span>
              </button>
              <button onClick={() => { setCurrentPage('realisations'); setIsMobileMenuOpen(false); }} className={`flex items-center space-x-2 px-3 py-2 rounded transition ${currentPage === 'realisations' ? 'bg-orange-500' : 'hover:bg-slate-600'}`}>
                <Image className="w-4 h-4" /><span>Réalisations</span>
              </button>
              <button onClick={() => { setCurrentPage('contact'); setIsMobileMenuOpen(false); }} className={`flex items-center space-x-2 px-3 py-2 rounded transition ${currentPage === 'contact' ? 'bg-orange-500' : 'hover:bg-slate-600'}`}>
                <MessageSquare className="w-4 h-4" /><span>Contact</span>
              </button>
              <button onClick={() => { setCurrentPage('rdv'); setIsMobileMenuOpen(false); }} className={`flex items-center space-x-2 px-3 py-2 rounded transition ${currentPage === 'rdv' ? 'bg-orange-500' : 'hover:bg-slate-600'}`}>
                <Calendar className="w-4 h-4" /><span>RDV</span>
              </button>
              {isAdmin ? (
                <>
                  <button onClick={() => { setCurrentPage('admin'); setIsMobileMenuOpen(false); }} className={`flex items-center space-x-2 px-3 py-2 rounded transition ${currentPage === 'admin' ? 'bg-orange-500' : 'hover:bg-slate-600'}`}>
                    <Settings className="w-4 h-4" /><span>Admin</span>
                  </button>
                  <button onClick={() => { handleLogout(); setIsMobileMenuOpen(false); }} className="flex items-center space-x-2 px-3 py-2 rounded hover:bg-red-600 transition">
                    <LogOut className="w-4 h-4" /><span>Déconnexion</span>
                  </button>
                </>
              ) : (
                <button onClick={() => { setCurrentPage('login'); setIsMobileMenuOpen(false); }} className={`flex items-center space-x-2 px-3 py-2 rounded transition ${currentPage === 'login' ? 'bg-orange-500' : 'hover:bg-slate-600'}`}>
                  <Lock className="w-4 h-4" /><span>Admin</span>
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );

  const LoginPage = () => (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <div className="text-center mb-6">
          <Lock className="w-16 h-16 text-orange-500 mx-auto mb-4" />
          <h1 className="text-xl md:text-3xl font-bold text-slate-800">Connexion Admin</h1>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-semibold mb-2">Utilisateur</label>
            <input ref={usernameRef} type="text" name="username" placeholder="Utilisateur" className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2">Mot de passe</label>
            <input ref={passwordRef} type="password" name="password" placeholder="Mot de passe" onKeyPress={(e) => e.key === 'Enter' && handleLogin()} className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500" />
          </div>
          {loginError && <div className="p-3 bg-red-100 text-red-700 rounded-lg text-sm">{loginError}</div>}
          <button onClick={handleLogin} className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-semibold">Se connecter</button>
        </div>
      </div>
    </div>
  );

  const AdminPage = () => (
    <div className="max-w-6xl mx-auto px-4 py-16">
      <div className="mb-8">
        <h1 className="text-2xl md:text-4xl font-bold text-slate-800">Gestion Disponibilités</h1>
      </div>
      {loadingDispo ? (
        <div className="text-center">Chargement...</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-lg md:text-2xl font-bold mb-4"><Plus className="w-6 h-6 inline mr-2 text-orange-500" />Ajouter</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold mb-2">Date</label>
              <input type="date" value={newDispo.date} onChange={(e) => setNewDispo({...newDispo, date: e.target.value})} min={new Date().toISOString().split('T')[0]} className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500" />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">Heures</label>
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2">
                {heuresDisponibles.map(h => (
                  <button key={h} onClick={() => toggleHeure(h)} className={`px-3 py-2 rounded-lg text-sm font-semibold ${newDispo.heures.includes(h) ? 'bg-orange-500 text-white' : 'bg-gray-100 hover:bg-gray-200'}`}>{h}</button>
                ))}
              </div>
            </div>
            <button onClick={ajouterDisponibilite} className="w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-lg font-semibold">Ajouter</button>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-lg md:text-2xl font-bold mb-4">Disponibilités</h2>
          <div className="space-y-3 max-h-96 overflow-y-auto">
            {disponibilites.sort((a, b) => new Date(a.date) - new Date(b.date)).map(d => (
              <div key={d.id} className="border p-4 rounded-lg">
                <div className="flex justify-between mb-2">
                  <p className="font-bold">{new Date(d.date + 'T00:00:00').toLocaleDateString('fr-FR', {weekday: 'long', day: 'numeric', month: 'long'})}</p>
                  <button onClick={() => supprimerDisponibilite(d.id)} className="text-red-500"><Trash2 className="w-5 h-5" /></button>
                </div>
                <div className="flex flex-wrap gap-2">
                  {d.heures.map(h => <span key={h} className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm">{h}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      )}
    </div>
  );

  const HomePage = () => (
    <div>
      <div className="bg-gradient-to-r from-slate-700 to-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-4">Expert en rénovation & aménagement</h1>
          <p className="text-lg md:text-xl mb-8">L’expérience au service de vos projets</p>
          <button onClick={() => setCurrentPage('rdv')} className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg text-base md:text-lg font-semibold">Prendre RDV</button>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-xl md:text-3xl font-bold text-center mb-12">Pourquoi Nous Choisir ?</h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-white rounded-lg shadow-lg">
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h3 className="text-lg md:text-xl font-bold mb-2">Qualité Garantie</h3>
          </div>
          <div className="text-center p-6 bg-white rounded-lg shadow-lg">
            <Clock className="w-16 h-16 text-blue-500 mx-auto mb-4" />
            <h3 className="text-lg md:text-xl font-bold mb-2">Respect Délais</h3>
          </div>
          <div className="text-center p-6 bg-white rounded-lg shadow-lg">
            <Briefcase className="w-16 h-16 text-orange-500 mx-auto mb-4" />
            <h3 className="text-lg md:text-xl font-bold mb-2">Professionnalisme</h3>
          </div>
        </div>
      </div>
      <div className="bg-slate-100 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-xl md:text-3xl font-bold text-center mb-8">Nos Services</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {services.map((s, i) => (
              <div key={i} className="bg-white p-6 rounded-lg shadow-md flex items-start space-x-4">
                <div className="text-orange-500">{s.icon}</div>
                <div><h3 className="text-lg md:text-xl font-bold mb-2">{s.titre}</h3><p className="text-gray-600">{s.description}</p></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const ServicesPage = () => (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <h1 className="text-2xl md:text-4xl font-bold text-center mb-12">Nos Services</h1>
      <div className="grid md:grid-cols-2 gap-8">
        {services.map((s, i) => (
          <div key={i} className="bg-white p-8 rounded-lg shadow-lg">
            <div className="text-orange-500 mb-4">{s.icon}</div>
            <h2 className="text-lg md:text-2xl font-bold mb-4">{s.titre}</h2>
            <p className="text-gray-700 mb-4">{s.description}</p>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2"><CheckCircle className="w-5 h-5 text-green-500" /><span>Devis gratuit</span></li>
              <li className="flex items-center space-x-2"><CheckCircle className="w-5 h-5 text-green-500" /><span>Matériaux qualité</span></li>
              <li className="flex items-center space-x-2"><CheckCircle className="w-5 h-5 text-green-500" /><span>Garantie décennale</span></li>
            </ul>
          </div>
        ))}
      </div>
      <div className="text-center mt-12">
        <button onClick={() => setCurrentPage('contact')} className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg text-base md:text-lg font-semibold">Demander Devis</button>
      </div>
    </div>
  );

  const RealisationsPage = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const realisations = [
      { id: 1, titre: "Réalisation 1", image: "/images/realisations/1.jpg" },
      { id: 2, titre: "Réalisation 2", image: "/images/realisations/2.jpg" },
      { id: 3, titre: "Réalisation 3", image: "/images/realisations/3.jpg" },
      { id: 4, titre: "Réalisation 4", image: "/images/realisations/4.jpg" },
      { id: 5, titre: "Réalisation 5", image: "/images/realisations/5.jpg" },
      { id: 6, titre: "Réalisation 6", image: "/images/realisations/6.jpg" },
    ];

    return (
      <div className="max-w-6xl mx-auto px-4 py-16">
        <h1 className="text-2xl md:text-4xl font-bold text-center mb-4">Nos Réalisations</h1>
        <p className="text-center text-gray-600 mb-12">Cliquez sur les images pour voir plus de détails</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {realisations.map((realisation) => (
            <div key={realisation.id} onClick={() => setSelectedImage(realisation)} className="cursor-pointer rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition transform hover:scale-105">
              <img src={realisation.image} alt={realisation.titre} className="w-full h-64 object-cover" />
              <div className="bg-white p-4">
                <h3 className="text-lg font-bold text-gray-800">{realisation.titre}</h3>
                <p className="text-sm text-gray-500 mt-2">👆 Cliquez pour voir en grand</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button onClick={() => setCurrentPage('contact')} className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg text-base md:text-lg font-semibold">Demander un Devis</button>
        </div>

        {selectedImage && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" onClick={() => setSelectedImage(null)}>
            <div className="max-w-2xl w-full bg-white rounded-lg overflow-hidden" onClick={(e) => e.stopPropagation()}>
              <img src={selectedImage.image} alt={selectedImage.titre} className="w-full" />
              <div className="p-6 text-center">
                <h2 className="text-2xl font-bold mb-4">{selectedImage.titre}</h2>
                <button onClick={() => setSelectedImage(null)} className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg">Fermer</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const ContactPage = () => (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-2xl md:text-4xl font-bold text-center mb-12">Contactez-nous</h1>
      <div className="grid md:grid-cols-2 gap-8">
        <div className="space-y-6">
          <div className="flex items-start space-x-4">
            <Phone className="w-6 h-6 text-orange-500 mt-1" />
            <div><h3 className="font-bold">Téléphone</h3><p>01 23 45 67 89</p></div>
          </div>
          <div className="flex items-start space-x-4">
            <Mail className="w-6 h-6 text-orange-500 mt-1" />
            <div><h3 className="font-bold">Email</h3><p>contact@brico.fr</p></div>
          </div>
          <div className="flex items-start space-x-4">
            <MapPin className="w-6 h-6 text-orange-500 mt-1" />
            <div><h3 className="font-bold">Adresse</h3><p>123 Avenue de la Construction<br />75000 Paris</p></div>
          </div>
          <div className="flex items-start space-x-4">
            <Clock className="w-6 h-6 text-orange-500 mt-1" />
            <div><h3 className="font-bold">Horaires</h3><p>Lun-Ven: 8h-18h<br />Sam: 9h-12h</p></div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-lg md:text-2xl font-bold mb-4">Message</h2>
          <div className="space-y-4">
            <input ref={contactNomRef} defaultValue={formData.nom} type="text" name="nom" placeholder="Nom" autoComplete="off" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500" />
            <input ref={contactEmailRef} defaultValue={formData.email} type="email" name="email" placeholder="Email" autoComplete="off" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500" />
            <input ref={contactTelRef} defaultValue={formData.telephone} type="tel" name="telephone" placeholder="Téléphone" autoComplete="off" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500" />
            <textarea ref={contactMessageRef} defaultValue={formData.message} name="message" placeholder="Message" rows="4" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500"></textarea>
            <button onClick={handleSubmit} className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-semibold">Envoyer</button>
          </div>
          {submitError && <div className="mt-4 p-4 bg-red-100 text-red-700 rounded-lg">{submitError}</div>}
          {submitSuccess && <div className="mt-4 p-4 bg-green-100 text-green-700 rounded-lg">Message envoyé!</div>}
        </div>
      </div>
    </div>
  );

  const RDVPage = () => {
    const datesDisponibles = disponibilites.map(d => d.date);
    const [selectedDate, setSelectedDate] = useState('');
    const heuresDisponiblesPourDate = selectedDate ? getHeuresDisponiblesPourDate(selectedDate) : [];
    
    return (
      <div className="max-w-2xl mx-auto px-4 py-16">
        <h1 className="text-2xl md:text-4xl font-bold text-center mb-4">Prendre Rendez-vous</h1>
        <p className="text-center text-gray-600 mb-12">Consultation gratuite</p>
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <div className="space-y-4">
            <input ref={nomRef} type="text" name="nom" placeholder="Nom *" autoComplete="off" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500" />
            <input ref={emailRef} type="email" name="email" placeholder="Email *" autoComplete="off" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500" />
            <input ref={telRef} type="tel" name="telephone" placeholder="Téléphone *" autoComplete="off" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500" />
            <select ref={serviceRef} name="service" defaultValue="" className="w-full px-4 py-2 border rounded-lg">
              <option value="">Service *</option>
              <option value="renovation">Rénovation</option>
              <option value="amenagement">Aménagement</option>
              <option value="carrelages">Carrelages</option>
              <option value="peinture">Peinture</option>
              <option value="enduit">Enduit</option>
              <option value="parquet">Parquet</option>
              <option value="montage-meuble">Montage de Meuble</option>
              <option value="installation-cuisine">Installation de Cuisine</option>
              <option value="installation-sdb">Installation de Salle de Bains</option>
              <option value="plomberie">Plomberie</option>
              <option value="electricite">Électricité Petite</option>
            </select>
            <select ref={dateRef} name="date" defaultValue="" onChange={(e) => setSelectedDate(e.target.value)} className="w-full px-4 py-2 border rounded-lg">
              <option value="">Date *</option>
              {datesDisponibles.sort().map(d => (
                <option key={d} value={d}>{new Date(d + 'T00:00:00').toLocaleDateString('fr-FR', {weekday: 'long', day: 'numeric', month: 'long'})}</option>
              ))}
            </select>
            <select ref={heureRef} name="heure" defaultValue="" disabled={!selectedDate} className="w-full px-4 py-2 border rounded-lg disabled:bg-gray-100">
              <option value="">{selectedDate ? 'Heure *' : 'Sélectionnez une date'}</option>
              {heuresDisponiblesPourDate.sort().map(h => <option key={h} value={h}>{h}</option>)}
            </select>
            <textarea ref={messageRef} name="message" rows="4" placeholder="Détails du projet" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500"></textarea>
            <button onClick={handleSubmit} className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-semibold">Confirmer</button>
          </div>
          {submitError && <div className="mt-6 p-4 bg-red-100 text-red-700 rounded-lg">{submitError}</div>}
          {submitSuccess && <div className="mt-6 p-4 bg-green-100 text-green-700 rounded-lg">RDV confirmé!</div>}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navigation />
      <main className="flex-1">
        {currentPage === 'home' && <HomePage />}
        {currentPage === 'services' && <ServicesPage />}
        {currentPage === 'realisations' && <RealisationsPage />}
        {currentPage === 'contact' && <ContactPage />}
        {currentPage === 'rdv' && <RDVPage />}
        {currentPage === 'login' && <LoginPage />}
        {currentPage === 'admin' && isAdmin && <AdminPage />}
      </main>
      <footer className="bg-slate-800 text-white py-8 mt-auto">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <img src="/images/logo/logo.png" alt="BTP Solutions Logo" className="w-8 h-8 object-contain" />

          </div>
          <p className="text-gray-400">© 2026 Brico Service Pro</p>
        </div>
      </footer>
    </div>
  );
}